/* 
 * 图片压缩
 * img    原始图片
 * width   压缩后的宽度
 * height  压缩后的高度
 * ratio   压缩比率 
 */
export function compress(img, width, height, ratio) {        
    var canvas, ctx, img64;
         
    canvas = document.createElement('canvas');        
    canvas.width = width;
    canvas.height = height;
         
    ctx = canvas.getContext("2d");        
    ctx.drawImage(img, 0, 0, width, height);
         
    img64 = canvas.toDataURL("image/jpeg", ratio);
         
    return img64;
  }


// dataurl 为传进来的base64格式的图片地址， return 返回的为file格式
export function base64ImgtoFile(dataurl, filename = 'file') { 
   let arr = dataurl.split(',')
   let mime = arr[0].match(/:(.*?);/)[1]
   let suffix = mime.split('/')[1]
   let bstr = atob(arr[1])
   let n = bstr.length
   let u8arr = new Uint8Array(n)
   while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
   }
   return new File([u8arr], `${filename}.${suffix}`, {
      type: mime
   })
}